// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"94efa5fe","488":"ecbfdacb"}[chunkId] + ".chunk.js";
};